module.exports = __webpack_public_path__ + "static/media/52.88768805.jpg";